import React, { memo } from "react";
import { css } from "@emotion/core";
import WithStyles from "shared/components/WithStyles";
import { DWEB_MAX_WIDTH, FONTS } from "shared/styles/base";

import { TEXTS } from "shared/components/Footer/constants";

const termsCss = css`
    height: 45px;
    background: #fd7685;

    .content {
        display: flex;
        max-width: ${DWEB_MAX_WIDTH}px;
        margin: 0 auto;
        height: 100%;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 0.85rem;
        font-family: ${FONTS.CERA};
    }
`;

function Terms() {
    return (
        <WithStyles cssProps={termsCss}>
            <div className="content" dangerouslySetInnerHTML={{ __html: TEXTS.COPYRIGHT }} />
        </WithStyles>
    );
}

export default memo(Terms);
